'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { FREE } from 'self-service-api/constants/ProductLevels';
import debounce from '../../utils/wtDebounce';
import AllPlansIncludeFooter from './AllPlansIncludeFooter';
import HighlightedFreeCard from './HighlightedFreeCard';
import HighlightedMerchCard from './HighlightedMerchCard';
import { borderStyle, StyledCardGrid } from '../common/MerchCardSharedComponents';
import { IsMobileContext, isWidthMobile } from './mobileUtils';
import MobileProductLevelSelector from './MobileProductLevelSelector';
import MerchCardsToShow from '../../constants/MerchCardsToShow';

const HubTierInfo = ({
  productLine
}) => {
  const productLevels = MerchCardsToShow[productLine];
  const [isMobile, setIsMobile] = useState(isWidthMobile(window.innerWidth));
  useEffect(() => {
    const resizeWindow = debounce(() => {
      setIsMobile(isWidthMobile(window.innerWidth));
    }, 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  const [selectedMobileProductLevel, setSelectedMobileProductLevel] = useState(productLevels[0]);
  const productLevelsToShow = isMobile ? [selectedMobileProductLevel] : productLevels;
  const merchCardComponents = productLevelsToShow.map((productLevel, index) => {
    const commonStyles = {
      msGridColumn: index + 1,
      // IE
      gridColumnStart: index + 1,
      paddingLeft: 32,
      paddingRight: 32,
      borderRight: index < productLevelsToShow.length - 1 ? borderStyle : 'none'
    };
    return productLevel === FREE ? /*#__PURE__*/_jsx(HighlightedFreeCard, {
      productLine: productLine,
      commonStyles: commonStyles
    }, productLevel) : /*#__PURE__*/_jsx(HighlightedMerchCard, {
      productLevel: productLevel,
      productLine: productLine,
      commonStyles: commonStyles
    }, productLevel);
  });
  return /*#__PURE__*/_jsx(IsMobileContext.Provider, {
    value: isMobile,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex-column align-center justify-center",
      children: [isMobile && /*#__PURE__*/_jsx(MobileProductLevelSelector, {
        productLine: productLine,
        productLevels: productLevels,
        onClick: productLevel => setSelectedMobileProductLevel(productLevel),
        selectedProductLevel: selectedMobileProductLevel
      }), /*#__PURE__*/_jsxs(StyledCardGrid, {
        columns: isMobile ? 1 : productLevels.length,
        isMobile: isMobile,
        children: [merchCardComponents, /*#__PURE__*/_jsx(AllPlansIncludeFooter, {
          productLevels: productLevels,
          borderStyle: borderStyle
        })]
      })]
    })
  });
};

export default HubTierInfo;